import React from "react";
import { FIELD_BASE, FIELD_BORDER, FIELD_INVALID } from "./fieldStyles";

interface TextInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "className"> {
  /** Draws the red border the forms apply by hand when a field fails. */
  invalid?: boolean;
  className?: string;
}

// The dashboard's text input. Replaces the class string repeated across the
// recipe, fitness, user and assignment forms.
const TextInput: React.FC<TextInputProps> = ({
  invalid = false,
  className = "",
  ...rest
}) => (
  <input
    aria-invalid={invalid || undefined}
    className={`${FIELD_BASE} ${
      invalid ? FIELD_INVALID : FIELD_BORDER
    } ${className}`}
    {...rest}
  />
);

export default TextInput;
